module.exports = __webpack_public_path__ + "5454b42f62e3fabe392063245cadf985.svg";